import styled from 'styled-components';


export const Div = styled.div`
    width:550px;
    height: 550px;
`